import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazySummaryView = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-summary", jiraSpaEntry: "async-summary" */ '@atlassian/jira-spa-apps-software-summary'
		),
);

export const SummaryPage = () => {
	return <LazyPage Page={LazySummaryView} pageId="software-summary" shouldShowSpinner />;
};
